import { WeworkLoginMessage } from './wework-login-message';
var WeworkMessage = /** @class */ (function () {
    function WeworkMessage() {
        this.weworkLoginMessage = new WeworkLoginMessage();
    }
    return WeworkMessage;
}());
export { WeworkMessage };
